export const theme = {
  current: 'coog',
};
